import React from "react";
import styles from "./InputBox.module.css";
import { secondaryTextColor, fw400, titleXL } from "../../../Global.module.css";

export default function InputBox({ defaultValue, action }) {
	const handleInput = (e) => {
		if (e.target.value.length <= 40) {
			action(e.target.value);
		}
	};

	return (
		<div className={styles.inputBox}>
			<input
				id={styles.inputBox}
				className={`${secondaryTextColor} ${titleXL} ${fw400}`}
				type="text"
				value={defaultValue}
				onChange={handleInput}
				maxLength="20"
				size="20"
				placeholder="Untitled"
				autoComplete="off"
			/>
		</div>
	);
}
